import { createLogger } from "./logger";

const logger = createLogger("spatius-startup");
let nextAttemptId = 0;
type StartupPhase = "sdk_initialization" | "avatar_download" | "first_render";

/** Local diagnostics only: never include credentials, user data or transcript text. */
export function createSpatiusStartupTiming(context: {
  source: "page_warmup" | "session";
  roomName?: string;
  avatarId?: string;
}) {
  const startupAttemptId = ++nextAttemptId;
  const startedAt = performance.now();
  let active: { phase: StartupPhase; startedAt: number } | null = null;
  const emit = (outcome: "started" | "completed" | "failed" | "cancelled", error?: unknown) => {
    if (!active) return;
    const now = performance.now();
    const data = {
      ...context,
      startupAttemptId,
      phase: active.phase,
      outcome,
      elapsedMs: Math.round((now - startedAt) * 10) / 10,
      phaseElapsedMs: Math.round((now - active.startedAt) * 10) / 10,
      ...(error ? { error: error instanceof Error ? error.message : String(error) } : {}),
    };
    if (outcome === "failed") logger.warn("Spatius avatar startup phase", data);
    else logger.info("Spatius avatar startup phase", data);
  };
  return {
    start(phase: StartupPhase) {
      active = { phase, startedAt: performance.now() };
      emit("started");
    },
    finish(outcome: "completed" | "failed" | "cancelled", error?: unknown) {
      emit(outcome, error);
      active = null;
    },
  };
}
